import { useDispatch, useSelector } from 'react-redux';
import { PinPointIcon } from '../../../../utils/svg';
import { isEmptyData } from '../../../../utils/helper';
import { setUser } from '../../../../store/reducers/user';

const RecentAddress = (props) => {
	const { onClose } = props;

	const dispatch = useDispatch();
	const { recentData } = useSelector((state) => state.location);
  const user = useSelector((state) => state.user);

	const handleClick = (data = null) => {
		if (isEmptyData(data?.latitude) || isEmptyData(data?.longitude)) return;
		dispatch(
			setUser({
        address: data?.address,
        city: data?.city,
        district: data?.district,
        village: data?.village,
        state: data?.state,
        postalCode: data?.postalCode ?? '',
        latitude: Number(data?.latitude),
        longitude: Number(data?.longitude),
        detail: data?.detail || user?.detail || null,
        firstName: data?.firstName || user?.firstName || null,
        lastName: data?.lastName || user?.lastName || null,
        email: data?.email || user?.email || null,
        primary_phone: data?.phone || user?.primary_phone || null,
			}),
		);
		onClose();
	};

  if (isEmptyData(recentData)) return null

	return (
		<>
			<div className='text-[var(--dark-gray)] font-semibold text-sm my-4'>Recent</div>
			<div className='space-y-2.5'>
				{recentData?.map((location, index) => (
					<div key={index} id='search_address_recent_location' className='[&:not(:last-child)]:border-b border-solid border-[var(--pin-ball)] p-2.5 flex items-center gap-2.5' onClick={() => handleClick(location)}>
						<PinPointIcon className='fill-gray-500 w-4 h-4 shrink-0' />
						<div className='space-y-0.5'>
							<div className='text-[var(--dark-gray)] text-sm font-semibold'>{location?.village}</div>
							<div className='text-[var(--dark-gray)] text-xxs'>{location?.address}</div>
						</div>
					</div>
				))}
			</div>
		</>
	);
};

export default RecentAddress;
